import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconSearch = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <circle cx="6.5" cy="6.5" r="5.75" stroke="currentColor" stroke-width="1.5" />
      <rect x="10.1303" y="10.7002" width="0.75" height="7.25" rx="0.375" transform="rotate(-45 10.1303 10.7002)" fill="currentColor" stroke="currentColor" stroke-width="0.75" />
    </svg>
  )
}

export default IconSearch